import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Minibusonrentinnmumbai() {



  const cardData = {
    keyword: " Mini Bus on Rent in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and spacious mini bus on rent in Mumbai, making group travel comfortable, safe, and convenient for weddings, corporate outings, airport transfers, school trips, pilgrimage tours, and outstation journeys. Our mini buses come in multiple seating capacities including 18, 20, 22, 25, and 30 seaters, equipped with pushback seats, air-conditioning, ample luggage space, and comfortable interiors designed for long-distance travel. With professional drivers and well-maintained vehicles, we ensure a smooth and stress-free journey across Mumbai and all major destinations. Mini bus rental pricing in Mumbai typically starts from around ₹25 to ₹40 per km depending on seating capacity and route, along with flexible local and outstation packages. We offer one-way trips, round trips, and customized group travel solutions with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for mini bus rental in Mumbai.",

"topPlaces": [
  {
    "title": "Mini Bus on Rent in Mumbai",
    "description": "Mini Bus on rent in Mumbai is an ideal transportation solution for group travel, family functions, corporate events, and sightseeing tours. With comfortable seating and ample space, it allows passengers to travel together conveniently and safely."
  },
  {
    "title": "Mini Bus Rental Service Mumbai",
    "description": "Mini Bus rental services in Mumbai are widely preferred for transporting groups efficiently across the city and beyond. These vehicles offer comfort, reliability, and convenience for various travel requirements."
  },
  {
    "title": "Mini Bus with Driver Mumbai",
    "description": "Mini Bus with driver services in Mumbai provide a hassle-free travel experience with professional chauffeurs handling navigation and traffic. It is a popular option for corporate groups, tourists, and family gatherings."
  },
  {
    "title": "Mumbai Airport Mini Bus Rental",
    "description": "Mumbai Airport Mini Bus rental services are perfect for group airport transfers. The vehicle offers comfortable seating and sufficient luggage space, making arrivals and departures smooth and convenient."
  },
  {
    "title": "Luxury Mini Bus Rental Mumbai",
    "description": "Luxury Mini Bus rentals in Mumbai are designed for passengers seeking premium group transportation. Modern interiors, comfortable seating, and enhanced amenities make them suitable for special occasions and executive travel."
  },
  {
    "title": "Mini Bus for Outstation Trips from Mumbai",
    "description": "Mini Buses are commonly rented for outstation journeys from Mumbai to destinations such as Lonavala, Pune, Mahabaleshwar, Nashik, and Shirdi. They provide a comfortable and enjoyable travel experience for groups."
  },
  {
    "title": "Corporate Mini Bus Rental Mumbai",
    "description": "Corporate Mini Bus rental services in Mumbai are ideal for employee transportation, conferences, seminars, and team outings. Businesses prefer them for efficient and comfortable group travel."
  },
  {
    "title": "Mini Bus for Family Trips Mumbai",
    "description": "Families traveling together in Mumbai often choose Mini Bus rentals because of their spacious seating and convenience. They are perfect for weddings, celebrations, pilgrimages, and holiday trips."
  },
  {
    "title": "Affordable Mini Bus Hire Mumbai",
    "description": "Affordable Mini Bus hire in Mumbai offers a cost-effective way for groups to travel together without compromising on comfort and safety. It is suitable for both local and outstation travel needs."
  },
  {
    "title": "Best Mini Bus Service Mumbai",
    "description": "The best Mini Bus services in Mumbai provide reliable transportation, experienced drivers, and well-maintained vehicles. They are widely used for corporate travel, family outings, airport transfers, and group tours."
  }
],






services: [
  {
    name: "Mini Bus on Rent Mumbai",
    description: "Mini bus on rent Mumbai offers spacious and comfortable group transportation for events, tours, and corporate travel. These buses are ideal for medium-sized groups with ample seating and luggage space. Professional drivers and well-maintained vehicles ensure safety. It guarantees a smooth and convenient travel experience."
  },
  {
    name: "Mini Bus Rental Mumbai",
    description: "Mini bus rental Mumbai provides flexible travel solutions for group journeys including local trips and outstation tours. Customers can choose from different seating capacities. Clean vehicles and experienced drivers enhance comfort. It ensures a reliable group travel experience."
  },
  {
    name: "Mini Bus Hire Mumbai",
    description: "Mini bus hire Mumbai offers convenient booking options for group travel needs. This service is ideal for weddings, picnics, and corporate outings. Spacious seating and comfortable interiors ensure a pleasant journey. It guarantees a hassle-free experience."
  },
  {
    name: "Mini Bus Booking Mumbai",
    description: "Mini bus booking Mumbai allows customers to reserve their vehicle easily with flexible options. Travelers can select seating capacity, pickup location, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mini Bus Service Mumbai",
    description: "Mini bus service Mumbai provides reliable transportation for group travel across the city and beyond. This service is suitable for family trips, corporate travel, and events. Professional drivers ensure safe journeys. It ensures a smooth and comfortable ride."
  },
  {
    name: "Mini Bus Price Mumbai",
    description: "Mini bus price Mumbai varies based on seating capacity, trip distance, and duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel efficiently. It ensures value for money."
  },
  {
    name: "Mini Bus Fare Mumbai",
    description: "Mini bus fare Mumbai is designed to be competitive for group travel. Fare depends on route, vehicle type, and travel plan. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "20 Seater Mini Bus Mumbai",
    description: "20 seater mini bus Mumbai is ideal for small to medium groups seeking comfortable travel. This vehicle offers adequate seating and luggage space. Suitable for city trips and short tours. It ensures a smooth and enjoyable journey."
  },
  {
    name: "25 Seater Mini Bus Mumbai",
    description: "25 seater mini bus Mumbai is perfect for larger groups and corporate outings. Spacious seating and comfort make it suitable for long-distance travel. Ideal for tours and events. It ensures a comfortable group journey."
  },
  {
    name: "Luxury Mini Bus Rental Mumbai",
    description: "Luxury mini bus rental Mumbai offers premium travel experience with comfortable seating, AC, and modern interiors. This service is ideal for corporate clients and special events. It guarantees a high-end and comfortable journey."
  },
  {
    name: "AC Mini Bus Mumbai",
    description: "AC mini bus Mumbai provides air-conditioned comfort for group travel in all weather conditions. This service ensures a pleasant travel experience during long journeys. Suitable for families and corporate groups. It ensures a relaxed ride."
  },
  {
    name: "Mini Bus for Wedding Mumbai",
    description: "Mini bus for wedding Mumbai offers convenient transportation for guests during wedding events. This service ensures timely pickup and drop for multiple locations. Spacious seating makes it ideal for group movement. It guarantees smooth event travel management."
  },
  {
    name: "Mini Bus for Corporate Travel Mumbai",
    description: "Mini bus for corporate travel Mumbai provides organized transportation for office staff and business events. This service is ideal for employee transport and corporate outings. Professional drivers ensure punctuality. It ensures efficient travel management."
  },
  {
    name: "Mini Bus for Outstation Mumbai",
    description: "Mini bus for outstation Mumbai offers reliable long-distance travel for group trips. This service is ideal for tours, pilgrimages, and vacations. Vehicles are maintained for highway performance. It ensures a safe and comfortable journey."
  },
  {
    name: "Cheap Mini Bus Rental Mumbai",
    description: "Cheap mini bus rental Mumbai offers budget-friendly options for group travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mini Bus Service Mumbai",
    description: "Best mini bus service Mumbai ensures top-quality vehicles and professional drivers for group travel. This service focuses on comfort, safety, and customer satisfaction. Multiple seating options are available. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mini Bus on Rent Mumbai", "Mini Bus Rental Mumbai"],
  ["Mini Bus Hire Mumbai", "Mini Bus Booking Mumbai"],
  ["Mini Bus Service Mumbai", "Mini Bus Price Mumbai"],
  ["Mini Bus Fare Mumbai", "20 Seater Mini Bus Mumbai"],
  ["25 Seater Mini Bus Mumbai", "Luxury Mini Bus Rental Mumbai"],
  ["AC Mini Bus Mumbai", "Mini Bus for Wedding Mumbai"],
  ["Mini Bus for Corporate Travel Mumbai", "Mini Bus for Outstation Mumbai"],
  ["Cheap Mini Bus Rental Mumbai", "Best Mini Bus Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Spacious Mini Bus on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers comfortable mini bus rental in Mumbai, ideal for group travel, school trips, corporate outings, and family functions."
  },
  {
    WhyChooseheading: "Perfect for Medium Group Travel",
    WhyChoosedescription: "Mini buses are suitable for 20 to 35 passengers, offering ample seating space and luggage capacity for smooth travel."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in handling group travel, ensuring safe and comfortable journeys."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for mini bus rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our mini bus rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All mini buses are regularly serviced, sanitized, and maintained for a comfortable group travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book mini buses for local Mumbai travel, events, airport transfers, or outstation trips with customizable packages."
  },
  {
    WhyChooseheading: "Trusted Group Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable mini bus rental in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide mini bus on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers mini bus rental services in Mumbai for local and outstation travel." },
  { question: "What seating capacity is available in mini buses?", answer: "We provide mini buses with seating capacity of 20 to 35 passengers." },
  { question: "Is mini bus suitable for long-distance travel?", answer: "Yes, mini buses are ideal for group travel on both city and long-distance routes." },
  { question: "Is rental available 24 hours?", answer: "Yes, our mini bus rental service operates 24/7." },
  { question: "Do you provide driver with mini bus?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup for groups?", answer: "Yes, we offer Mumbai airport pickup and drop services for group travel." },
  { question: "Can I book for events and weddings?", answer: "Yes, we provide mini bus rental for weddings, corporate events, and school trips." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pradeep Jadhav",
    feedback: "Mini bus on rent in Mumbai with Royal Route Cabs was perfect for our group trip. The vehicle was spacious, clean, and very comfortable for everyone.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "Great experience booking a mini bus in Mumbai. The ride was smooth, the driver was professional, and the entire journey felt well-organized and hassle-free.",
    rating: 5
  }
];













  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/mini-bus-on-rent-mumbai.jpg", // replace if needed
  "description": "Book mini bus on rent in Mumbai with Royal Route Cabs for group travel, weddings, corporate trips, and outstation journeys. Available in 20-seater, 25-seater, AC, and luxury mini buses with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "25", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mini-bus-on-rent-mumbai"
  }
};







  return (
    <div>
<Helmet>
  <title>Mini Bus on Rent in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book mini bus on rent in Mumbai with Royal Route Cabs. Ideal for weddings, corporate travel, and group tours. Available in 20 & 25 seater AC & luxury mini buses."
  />

  <meta
    name="keywords"
    content="mini bus on rent mumbai, mini bus rental mumbai, mini bus hire mumbai, mini bus booking mumbai, mini bus service mumbai, mini bus price mumbai, mini bus fare mumbai, 20 seater mini bus mumbai, 25 seater mini bus mumbai, luxury mini bus rental mumbai, ac mini bus mumbai, mini bus for wedding mumbai, mini bus for corporate travel mumbai, mini bus for outstation mumbai, cheap mini bus rental mumbai, best mini bus service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinnmumbai;